import User from "discourse/models/user";
import { computed } from "@ember/object";
import { ajax } from "discourse/lib/ajax";
import getURL from "discourse-common/lib/get-url";

export default class AnonymousEmailLog {
  constructor(attrs) {
    this.opened = attrs.opened;
    this.sent = attrs.sent;
    this.post_author = attrs.post_author;
    this.post_created_at = attrs.post_created_at;
    this.post_description = attrs.post_description;
    this.post_url = attrs.post_url;
  }

  @computed("sent", "opened")
  get open_rate() {
    return `${Math.round(((this.opened || 0) / this.sent) * 100)}%`;
  }

  static create(attrs) {
    attrs = attrs || {};

    if (attrs.post_author) {
      attrs.post_author = User.create(attrs.post_author);
    }

    if (attrs.post_url) {
      attrs.post_url = getURL(attrs.post_url);
    }
    return new AnonymousEmailLog(attrs);
  }

  static async findAll(offset) {
    offset = offset || 0;
    try {
      const logs = await ajax(
        `/admin/plugins/anonymous-email-log/summary.json?offset=${offset}`,
      );
      return logs.map((log) => AnonymousEmailLog.create(log));
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
